export const config = {
  colors: {
    type: 'boolean',
  },
}
